export default "__VITE_ASSET__DsU0saQw__"